import { Component, Input, OnInit, ViewChild } from '@angular/core';
import moment from 'moment';
import { BinderQRScanHistory } from 'src/app/models/binder/binder-QR-scan-history.model';
import { GenericModalComponent } from '../../generic-modal/generic-modal.component';

@Component({
	selector: 'binder-qr-scan-history',
	templateUrl: './binder-qr-scan-history.component.html',
	styleUrls: ['./binder-qr-scan-history.component.scss', '../../stylesheets/job-actions.scss', '../../stylesheets/job-main.scss', '../../stylesheets/job-inputs.scss']
})
export class BinderQrScanHistoryComponent implements OnInit {

	@ViewChild('qrScanHistoryList', {static: true}) public modal: GenericModalComponent;
	@Input() public binderQRScanHistory: BinderQRScanHistory[] = null;

	public readonly moment = moment;
	constructor() { }

	ngOnInit(): void {
	}

	public close(): void {
		this.modal.hide();
	}

	public open(): void {
		this.modal.open();
	}
}
